import { useState, useRef, useEffect } from 'react';

/**
 * Dropdown simple sin Radix UI. Usa click-outside-to-close.
 *
 * @param {ReactNode} trigger   — elemento clickeable que abre/cierra el menu
 * @param {ReactNode} children  — items del dropdown (usar `DropdownItem`)
 * @param {'start'|'end'} align — alineación horizontal (default 'start')
 */
export const SimpleDropdown = ({ trigger, children, align = 'start' }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <div onClick={() => setOpen(!open)}>{trigger}</div>
      {open && (
        <div
          className={`absolute z-50 min-w-[200px] bg-popover border rounded-2xl shadow-lg py-1 ${
            align === 'end' ? 'right-0' : 'left-0'
          } bottom-full mb-2`}
          onClick={() => setOpen(false)}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export const DropdownItem = ({ children, onClick, className = '', ...rest }) => (
  <button
    type="button"
    className={`w-full text-left px-3 py-2 text-sm hover:bg-accent hover:text-accent-foreground transition-colors flex items-center ${className}`}
    onClick={onClick}
    {...rest}
  >
    {children}
  </button>
);
